export const CT_GAME_SLUG = {
	LOTTO_459: ['loto-4-59', 'loto-4-59-luckia'],
	LOTTO_545: ['lotto-5-45'],
	LOTTO_645: ['lotto-6-45'],
}